export default __webpack_public_path__ + "static/media/drone12.537b7213.jpg";